import axios from 'axios'
import moment from 'moment'

const notifications = {
  state: {
    notificationList: {
      data: [],
      timestamp: moment().unix()
    }
  },
  mutations: {
    SET_NOTIFICATION_LIST (state, list) {
      state.notificationList.data = list
      state.notificationList.timestamp = moment().unix()
    },
    SET_NOTIFICATION_READ (state, item) {
      let notifications = state.notificationList.data.filter(notifi => item.notificationIds.find(id => notifi.id === id)) // find(notification => notification.id === item.id)
      if (notifications.length !== 0) {
        notifications.forEach(obj => {
          obj.read = true
        })
      }
    },
    SET_ALL_NOTIFICATIONS_READ (state) {
      state.notificationList.data.forEach(notification => {
        notification.read = true
      })
    },
    REMOVE_NOTIFICATION_INFO (state) {
      state.notificationList = {
        data: [],
        timestamp: moment().unix()
      }
    }
  },
  actions: {
    fetchNotifications ({commit, dispatch}, {params}) {
      return new Promise((resolve, reject) => {
        axios.get('/api/v1/notifications', {params: params})
          .then(response => {
            commit('SET_NOTIFICATION_LIST', response.data.notifications)
            resolve(response)
          })
          .catch(error => {
            dispatch('errorsHandler', {params: error})
            // reject(error)
          })
      })
    },
    setNotificationRead ({commit}, {params}) {
      return new Promise((resolve, reject) => {
        axios.put('/api/v1/notifications/read', params)
          .then(response => {
            commit('SET_NOTIFICATION_READ', params)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    setAllNotificationsRead ({commit, getters}, {params}) {
      return new Promise((resolve, reject) => {
        axios.put('/api/v1/notifications/readAll', params)
          .then(response => {
            commit('SET_ALL_NOTIFICATIONS_READ')
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    setNotificationSettings ({commit, getters}, {params}) {
      return new Promise((resolve, reject) => {
        axios.put('/api/v1/notifications/setting', params)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  },
  getters: {
    getNotifications (state) {
      return state.notificationList.data
    },
    getNotificationsTime (state) {
      return state.notificationList.timestamp
    }
  }
}

export default notifications
